import Image from 'app/Components/Shared/Image/image';
import React, {useMemo, useState} from 'react';
import {connect} from 'react-redux';
import ServiceBoxRegular from 'app/Components/Shared/ServiceBox/ServiceBoxRegular/ServiceBoxRegular';
import Config from 'app/Config';
import toggleDown from '../../../assets/images/toggleDown.svg';
import {navigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import {getActionTitle, getActionPermission, reportGA} from '../../../utils/functions';
import {setIsShowPopup} from '../../../BusinessDashboardSlice';

const ActionsPanel = ({
  title,
  actions,
  expandedText,
  collapsedText,
  setIsShowPopup,
  allowedScActions,
  allowedSuspendAction,
  allowedCellular,
  allowedBusinessReports,
  allowedUploadOrgUsersList,
  roles,
  isRent,
}) => {
  const [isExpanded, setIsExpanded] = useState(() => false);
  const toggleText = isExpanded ? expandedText : collapsedText;

  const handleToggle = () => setIsExpanded((val) => !val);

  const isServiceManager = useMemo(() => {
    return roles?.includes('CREDENTIALS_SERVICEMANAGER') ?? false;
  }, [roles]);

  const permissions = useMemo(
    () => ({
      allowedScActions,
      allowedBusinessReports,
      allowedCellular,
      allowedUploadOrgUsersList,
    }),
    [allowedScActions, allowedBusinessReports, allowedCellular, allowedUploadOrgUsersList],
  );

  const actionsWithDetails = useMemo(() => {
    return actions?.map((action) => {
      const allowDependingOnRent = !action?.onlyForRent?.value ? true : (isRent ? true : false);
      const actionTitle = getActionTitle(action?.actionName?.value);
      const isAllowed = getActionPermission(actionTitle, permissions, isServiceManager, allowDependingOnRent);

      return {...action, actionTitle, isAllowed};
    });
  }, [actions, permissions, isServiceManager, isRent]);

  const actionCallback = (action) => {
    if (action?.isAllowed) {
      reportGA(action.actionTitle);
      navigateTo(action?.actionUrl?.value);
    } else {
      setIsShowPopup(true);
    }
  };

  return (
    <div className='business-dashboard-actions-panel'>
      {title && <span className='actions-title'>{title}</span>}
      <div className={`actions-list ${isExpanded ? '' : 'collapsed'}`}>
        {actionsWithDetails?.map((action, index) => (
          <ServiceBoxRegular
            key={index}
            badgeText={action?.tagText?.value}
            badgeColorProperty={action?.tagColor?.value}
            badgeBackgroundColorProperty={action?.tagBackgroundColor?.value}
            isHaveBadge={!!action?.tagText?.value}
            backgroundImageUrl={Config.epiBaseUrl + action?.actionIcon?.value?.url}
            actionUrl={Config.epiBaseUrl + action?.actionUrl?.value}
            actionName={action?.actionTitle}
            action={action}
            callback={(action) => actionCallback(action)}
          />
        ))}
      </div>
      <div className='toggle-container' onClick={handleToggle}>
        <span className='toggle-text'>{toggleText}</span>
        <Image src={toggleDown} alt='Toggle' className={`toggle-icon ${isExpanded ? 'expanded' : 'collapsed'}`} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allowedScActions: state.portalsBlock.allowedScActions,
    allowedSuspendAction: state.portalsBlock.allowedSuspendAction,
    allowedCellular: state.portalsBlock.allowedCellular,
    allowedBusinessReports: state.portalsBlock.allowedBusinessReports,
    allowedUploadOrgUsersList: state.portalsBlock.allowedUploadOrgUsersList,
    roles: state.authentication.loginData.userDetails.RoleList,
    isRent: state.portalsBlock.isRent,
  };
};

const mapDispatchToProps = {setIsShowPopup};
export default connect(mapStateToProps, mapDispatchToProps)(ActionsPanel);
